import { useState, useCallback, useEffect } from 'react';
import { getOrderList } from './src-utils-chatbot-order-tracking-response-handlers.js';
import { API_ENDPOINTS } from './src-config-api-config.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { useIdentity } from '@vp/auth-react';
import { getChatbotToken, getRestId } from './src-utils-session-storage-utils.js';

const useCBFetchOrders = () => {
  const identity = useIdentity();
  const { logCustomAttributesNR } = useNRLogging();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [requestData, setRequestData] = useState();
  const trigger = useCallback((msg) => {
    setRequestData(msg);
  }, []);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        if (requestData) {
          const chatbotToken = getChatbotToken();
          const { authorizationHeader, canonicalId } = identity;
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", authorizationHeader);
          myHeaders.append("Chatbot-Authorization", `Bearer ${chatbotToken}`);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
              order_page: requestData.pageNumber.toString(),
              shopper_id: canonicalId || "",
              request_id: getRestId() || ""
            }),
            redirect: "follow"
          };
          logCustomAttributesNR("ca-chatbot-api-request", {
            logLevel: "info",
            message: "Fetching orders from chatbot API",
            pageNumber: requestData.pageNumber,
            apiType: "getChatbotOrders"
          });
          fetch(`${API_ENDPOINTS.CHATBOT_BASE_URL()}/orders`, requestOptions).then((response) => {
            if (!response.ok) {
              const error2 = new Error(`API responded with status: ${response.status}`);
              error2.name = "ApiError";
              throw error2;
            }
            return response.json();
          }).then((result) => {
            const orderlist = getOrderList(result);
            setData(orderlist);
            setError(void 0);
            logCustomAttributesNR("ca-chatbot-api-response", {
              logLevel: "info",
              message: "Fetching orders from chatbot API success",
              apiType: "getChatbotOrders"
            });
          });
        }
      } catch (error2) {
        setError(error2);
        logCustomAttributesNR("ca-chatbot-api-error", {
          errorName: error2.name,
          errorStack: error2.stack,
          message: error2.message,
          logLevel: "error",
          apiType: "getChatbotOrders"
        });
      } finally {
        setLoading(false);
        setRequestData(void 0);
      }
    };
    fetchData();
  }, [requestData]);
  return {
    data,
    loading,
    error,
    trigger
  };
};

export { useCBFetchOrders };
//# sourceMappingURL=src-hooks-chatbot-useCBFetchOrders.js.map
